import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'file-icon',
  templateUrl: './file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FileIconComponent {}
